import SegurancaApi from "./Services/SegurancaApi";
import TokenExchangeApi from './Services/TokenExchangeApi'
import TokenExchangePublic from './Services/TokenExchangePublic'

export default {
  SegurancaApi,
  TokenExchangeApi,
  TokenExchangePublic,
}